import React, { Component } from 'react';
import { connect } from 'react-redux';
import {DataTable} from 'primereact/datatable';
import {Dropdown} from 'primereact/dropdown';
import {Column} from 'primereact/column';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';
import {Button} from 'primereact/button';
import {OverlayPanel} from 'primereact/overlaypanel';
import {InputSwitch} from 'primereact/inputswitch';
import { DROPDOWN_CONFIG, TIMEOFFTYPE_SUBMENU_ID } from '../../shared/Config';
import {  DURATION_DISPLAY, ALLOWANCE_ENTITLEMENT } from './TimeOffTypeConst';
import FooterButton from '../../shared/UI/FooterButton/FooterButton';
import {  REDIRECT_TO_URL, HASACCESS } from '../../shared/utility';
import {Toast} from 'primereact/toast';
import Messages from '../../shared/UI/Messages/Messages';
import * as actions from '../../store/actions/index';

class TimeOffType extends Component {
    state = {
        // fields : [
        //     {label : 'Name',value : 'Name'},
        //     {label : 'Description',value : 'Description'},
        //     {label : 'Type',value : 'Type'},
        //     {label : 'BookingOffset',value : 'BookingOffset'},
        //     {label : 'QuotaType',value : 'QuotaType'},            
        //     {label : 'Quota_Starting_date',value : 'Quota_Starting_date'},
        //     {label : 'BookingEligibility',value : 'BookingEligibility'},
        //     {label : 'Recurring_Starts_When',value : 'Recurring_Starts_When'},
        //     {label : 'payCode',value : 'payCode'},
        //     {label : 'class',value : 'class'},
        //     {label : 'Deduct_From',value : 'Deduct_From'},
        //     {label : 'Allowance',value : 'Allowance'},
        //     {label : 'Duration_Display_According_To',value : 'Duration_Display_According_To'},
        //     {label : 'numberofticketentitlement',value : 'numberofticketentitlement'},
        //     {label : 'numberofvisaentitlement',value : 'numberofvisaentitlement'},
        //     {label : 'AllowanceEntitlementPeriod',value : 'AllowanceEntitlementPeriod'},
        //     {label : 'Allowvisaentitlement',value : 'Allowvisaentitlement'},
        //     {label : 'Allowmultiplebookinginayear',value : 'Allowmultiplebookinginayear'},
        //     {label : 'Deductible',value : 'Deductible'},
        //     {label : 'Excludeweekends',value : 'Excludeweekends'},
        //     {label : 'Excludecompanyholidays',value : 'Excludecompanyholidays'},
        //     {label : 'Allowvisaentitlement',value : 'Allowvisaentitlement'},
        //     {label : 'Evidenceattachmentmust',value : 'Evidenceattachmentmust'},
        // ],
        // relationalOperators: [
        //     {label : '<',value : '<'},
        //     {label : '>',value : '>'},
        //     {label : '=',value : '='},
        //     {label : '<=',value : '<='},
        //     {label : '>=',value : '>='},
        // ],

        // ContionLogicalOperators: [
            
        //     {label : 'AND',value : 'AND'},
        //     {label : 'OR',value : 'OR'}
        // ],

        // Parameter : '',
        // SlabFrom:'',
        // SlabTo:'',
        // ConditionRelationalOperator: '',
        // ContionLogicalOperator: '',
        // slabs : [],

        // dataTableValue : [{
        //     data: ''
        // }],
        timeOffId : null,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        type:'add',
        Name : '',
        Description : '',
        Type : null,
        BookingOffset : null,
        QuotaType : null,
        Quota_Starting_date :null,
        BookingEligibility : null,
        Recurring_Starts_When : null,
        payCode : '',
        class : null,
        Deduct_From : null,
        Allowance : '',
        Duration_Display_According_To : null,
        numberofticketentitlement : 0,
        numberofvisaentitlement : 0,
        AllowanceEntitlementPeriod : null,
        Allowvisaentitlement : false,
        Allowmultiplebookinginayear : false,
        Allowticketentitilement : false,
        Deductible : false,
        Excludeweekends : false,
        Excludecompanyholidays : false,
        Evidenceattachmentmust : false,
        CreatedBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        CreatedDate : new Date(),
        loadOnce:true,
        loadingFetch:false
    }


    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div className="actionCenter">
                <Button onClick={() => this.delete(rowIndex)} icon="pi pi-trash"  className="p-button-danger"/>
            </div>;
    }
   

    delete = (ind) => {
       
        const filteredValue = this.state.slabs.filter((slab , index) => {

            return ind !== index;
         
        });
        this.setState({slabs:filteredValue});

    }

    
    saveData = async () => {
        this.setState({ loadingFetch: true });
        
        //public Guid TimeOffId { get; set; }
        //public DateTime? UpdatedDate { get; set; }
        //public string UpdatedBy { get; set; }

        var data = {
            Name : this.state.Name,
            Type :this.state.Type,
            BookingOffset : this.state.BookingOffset,
            QuotaType : this.state.QuotaType,
            QuotaStartingDate : parseInt(this.state.Quota_Starting_date) ,
            BookingEligibility : this.state.BookingEligibility,
            RecurringStartsWhen : parseInt(this.state.Recurring_Starts_When),
            RecurringFrequency : 0,
            PayCode : this.state.payCode,
            Class : this.state.class,
            Deductible : this.state.Deductible,
            ColourReference : 0,
            DeductFrom : this.state.Deduct_From,
            BookingType : 0,
            ViewInCalendar : false,
            Allowance : this.state.Allowance,
            AllowRequestOnNonWorkingDays : false,
            BalanceCalculation : 0,
            Unit : 0,
            PermittedFractionUnitDay : 0,
            PermittedFractionUnit : 0,
            ActivateCanclellationWorkflow : false,
            DurationDisplayAccordingTo : this.state.Duration_Display_According_To,
            AccountBookingOffsettingMonth : 0,
            AbsenceCountingMethodConsiderHoliday : false,
            AbsenceCountingMethodCalculationBasedOn : 0,
            PayoutEligibility : true,
            BookingEligibility: this.state.BookingEligibility,
            PayoutPayComponentGroup : '',
            PayoutPayComponent : '',
            PayComponentOnTermination : '',
            Excludeweekends : this.state.Excludeweekends,
            Excludecompanyholidays : this.state.Excludecompanyholidays,
            Allowmultiplebookinginayear : this.state.Allowmultiplebookinginayear,
            CompanyId : this.state.CompanyId,
            Allowticketentitilement : this.state.Allowticketentitilement,
            Numberofticketentitlement : this.state.numberofticketentitlement,
            Allowvisaentitlement : this.state.Allowvisaentitlement,
            Numberofvisaentitlement : this.state.numberofvisaentitlement,
            Evidenceattachmentmust : this.state.Evidenceattachmentmust,
            AllowanceEntitlementPeriod : this.state.AllowanceEntitlementPeriod,
            IsActive : true,
            CreatedDate : this.state.CreatedDate,
            CreatedBy : this.state.CreatedBy,
            Description : this.state.Description,
            //QuotaStartingDate : this.state.Quota_Starting_date,
        }
        // resetData = () => {
        //     // Reset the state to its initial values
        //     this.setState({
        //         display : true,
        //         type : 'add',
        //         Name : '',
        //         Description : '',
        //         Type : '',
        //         BookingOffset : '',
        //         QuotaType : '',
        //         Quota_Starting_date :'',
        //         BookingEligibility : '',
        //         Recurring_Starts_When : '',
        //         payCode : '',
        //         class : '',
        //         Deduct_From : '',
        //         Allowance : '',
        //         Duration_Display_According_To : '',
        //         numberofticketentitlement : '',
        //         numberofvisaentitlement : '',
        //         AllowanceEntitlementPeriod : '',
        //         Allowvisaentitlement : '',
        //         Allowmultiplebookinginayear : '',
        //         Allowticketentitilement : '',
        //         Deductible : '',
        //         Excludeweekends : '',
        //         Excludecompanyholidays : '',
        //         Evidenceattachmentmust : '',
            
               
        //     });
        // }

        try {
            // Call the processDynamicData action to handle the API call
            await this.props.processDynamicData('timeOffType', 'save', data, (error, result) => {
                if (error) {
                    // Display error message if API call fails
                    this.setState({ loadingFetch: false });
                    this.growl.show({ severity: 'error', summary: 'Error', detail: error });
                } else {
                    // Handle success case
                    this.setState({ loadingFetch: false });
                    this.growl.show({ severity: 'success', summary: 'Success', detail: 'Data saved successfully!' });
                    // Reset or navigate after success if needed
                }
            });
        } catch (error) {
            // Handle unexpected errors
            this.setState({ loadingFetch: false });
            this.growl.show({ severity: 'error', summary: 'Error', detail: 'Unexpected error occurred!' });
        }
    




        if(this.state.type === 'edit'){
            data.TimeOffId = this.state.timeOffId;
            data.UpdatedDate = this.state.CreatedDate;
            data.UpdatedBy = this.state.CreatedBy;
        }

  

        let Timeofftypeslab = []
             
       
        if(this.state.slabs && this.state.slabs.length > 0){
            Timeofftypeslab = this.state.slabs.map(slab=>{
                let slabData = {Parameter:slab.Parameter,ParameterType:slab.ParameterType,ParameterValue:slab.ParameterValue,SlabFrom:slab.SlabFrom,ConditionRelationalOperator:slab.ConditionRelationalOperator,SlabTo:slab.SlabTo,ContionLogicalOperator:slab.ContionLogicalOperator,CompanyId:slab.CompanyId,CreatedDate:slab.CreatedDate,CreatedBy:slab.CreatedBy,IsActive:slab.IsActive}
                if(this.state.type === 'edit'){
                    slabData = {timeoffTypeslabId: (slab.timeoffTypeslabId !==undefined) ? slab.timeoffTypeslabId : '', timoffTypeId:slab.timoffTypeId,Parameter:slab.Parameter,ParameterType:slab.ParameterType,ParameterValue:slab.ParameterValue,SlabFrom:slab.SlabFrom,ConditionRelationalOperator:slab.ConditionRelationalOperator,SlabTo:slab.SlabTo,ContionLogicalOperator:slab.ContionLogicalOperator,CompanyId:slab.CompanyId,UpdatedDate:this.state.CreatedDate,UpdatedBy:this.state.CreatedBy,IsActive:slab.IsActive}
                }
                return slabData;
            })
        }
      
      
        let valueData =  {
            TimeOffType : data,
            Timeofftypeslab :Timeofftypeslab
        }

        this.props.processDynamicData('leaveType',this.state.type,valueData,'GetTimeOff');

        if(this.state.type !=='add'){
            localStorage.removeItem('GetTimeOff?Id='+this.state.timeOffId);
        }
    }

    addSlabs = () => {    
        let newObj = {Parameter: this.state.Parameter,ParameterType:'',ParameterValue: '',SlabFrom:this.state.SlabFrom,ConditionRelationalOperator:this.state.ConditionRelationalOperator,SlabTo:this.state.SlabTo, value : this.state.SlabFrom+ ' '+this.state.ConditionRelationalOperator+' '+this.state.SlabTo, ContionLogicalOperator:this.state.ContionLogicalOperator, CompanyId:this.state.CompanyId, CreatedDate:this.state.CreatedDate, CreatedBy:this.state.CreatedBy,IsActive:true};
        if(this.state.type === 'edit'){
            newObj.timoffTypeId = this.state.timeOffId
            newObj.UpdatedDate = this.state.CreatedDate;
            newObj.UpdatedBy = this.state.CreatedBy;
        }

        let slab = [...this.state.slabs, newObj];
        this.setState({slabs:slab,Parameter:'' ,ParameterType:'',ParameterValue:'',SlabFrom:'',ConditionRelationalOperator:'',SlabTo:'',ContionLogicalOperator:''})
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });  
    }

    overlayPanel = (event,type) => {
        let html = '';
        if(type === 'Type'){
            html = (
                <div>
                    <h1>PERMANENT ACCOUNT</h1>
                    <p>This account will be created once per lifetime but the frequency of accruals can vary from daily, weekly, monthly, annually etc</p>
                    <h1> RECURRING ACCOUNT</h1>
                    <p>This account has a window of one year eligibility which can be extended to certain months though extendable booking feature (Exception)</p>
                </div>             
            )
        }

        let dataTableValue = {...this.state.dataTableValue}
        dataTableValue[0].data = html;
        this.setState({data:dataTableValue});
        this.overlayPanel2.toggle(event);
    }




    componentDidMount(){
        let type = this.props.match.params.type;  
        let id = this.props.match.params.id; 
        this.setState({loadingFetch:true});

        this.getAccess = HASACCESS(TIMEOFFTYPE_SUBMENU_ID);

        this.props.getMasterKeywordList('TimeOffType_Type'); 
        setTimeout(()=> {
            this.props.getMasterKeywordList('Booking_Offset'); 
        }, 1000);
        
        setTimeout(()=> {
            this.props.getMasterKeywordList('Quota_Starting_date'); 
        }, 2000);
       
        setTimeout(()=> {
            this.props.getMasterKeywordList('Booking_Elibility'); 
        }, 3000);

        setTimeout(()=> {
            this.props.getMasterKeywordList('Recurring_Starts_When'); 
        }, 4000);

        setTimeout(()=> {
            this.props.getMasterKeywordList('QUOTA_TYPE');  
        }, 4500);

        setTimeout(()=> {
            this.props.getMasterKeywordList('TimeoffType_Class');  
        }, 5000);

        setTimeout(()=> {
            this.props.getMasterKeywordList('TimeoffType');  
        }, 5500);

        

        setTimeout(()=> {
            if(type !== 'add'){
                this.fetchSingleProcess(id);
            }
            this.setState({loadingFetch:false});
        }, 6000);
        

    }
    
    fetchSingleProcess = (id) => {
        localStorage.removeItem('GetTimeOff?Id='+id);
        this.props.getMasterTableList('GetTimeOff?Id='+id); 
        
    }

    componentDidUpdate(){
        let timeofftype = (this.props.fetchData.timeofftype) ? this.props.fetchData.timeofftype : undefined;
        if(timeofftype!==undefined && this.state.loadOnce) {
            this.setState({type:'edit',loadOnce:false,timeOffId:timeofftype.timeOffId, Name:timeofftype.name, 
                Recurring_Starts_When: String(parseInt(timeofftype.recurringStartsWhen + '')) || '',

             Quota_Starting_date:String(parseInt(timeofftype.quotaStartingDate + '')),Type:String(parseInt(timeofftype.type + '')), BookingOffset:String(parseInt(timeofftype.bookingOffset + '')), QuotaType:String(parseInt(timeofftype.quotaType + '')),  BookingEligibility:timeofftype.bookingEligibility + "", RecurringFrequency:timeofftype.recurringFrequency, payCode:timeofftype.payCode, class:String(parseInt(timeofftype.class + '')), Deductible:timeofftype.deductible, ColourReference:timeofftype.colourReference, Deduct_From:timeofftype.deductFrom, BookingType:timeofftype.bookingType, ViewInCalendar:timeofftype.viewInCalendar, Allowance:timeofftype.allowance, AllowRequestOnNonWorkingDays:timeofftype.allowRequestOnNonWorkingDays, BalanceCalculation:timeofftype.balanceCalculation, Unit:timeofftype.unit, PermittedFractionUnitDay:timeofftype.permittedFractionUnitDay, PermittedFractionUnit:timeofftype.permittedFractionUnit, ActivateCanclellationWorkflow:timeofftype.activateCanclellationWorkflow, Duration_Display_According_To:timeofftype.durationDisplayAccordingTo, AccountBookingOffsettingMonth:timeofftype.accountBookingOffsettingMonth, AbsenceCountingMethodConsiderHoliday:timeofftype.absenceCountingMethodConsiderHoliday, AbsenceCountingMethodCalculationBasedOn:timeofftype.absenceCountingMethodCalculationBasedOn, PayoutPayComponentGroup:timeofftype.payoutPayComponentGroup, PayoutPayComponent:timeofftype.payoutPayComponent, PayComponentOnTermination:timeofftype.payComponentOnTermination, Excludeweekends:timeofftype.excludeweekends, Excludecompanyholidays:timeofftype.excludecompanyholidays, Allowmultiplebookinginayear:timeofftype.allowmultiplebookinginayear, CompanyId:timeofftype.companyId, Allowticketentitilement:timeofftype.allowticketentitilement, numberofticketentitlement:timeofftype.numberofticketentitlement, Allowvisaentitlement:timeofftype.allowvisaentitlement, numberofvisaentitlement:timeofftype.numberofvisaentitlement, Evidenceattachmentmust:timeofftype.evidenceattachmentmust, AllowanceEntitlementPeriod:timeofftype.allowanceEntitlementPeriod, IsActive:timeofftype.isActive, Description:timeofftype.description})
            
            let Timeofftypeslab = [];
            if(this.props.fetchData.timeofftypeslab!==undefined && this.props.fetchData.timeofftypeslab.length > 0){
                Timeofftypeslab = this.props.fetchData.timeofftypeslab.map(slab=>{
                    return {timeoffTypeslabId: slab.timeoffTypeslabId, timoffTypeId:slab.timoffTypeId, Parameter:slab.parameter,ParameterType:slab.parameterType,ParameterValue:slab.parameterValue,SlabFrom:slab.slabFrom,ConditionRelationalOperator:slab.conditionRelationalOperator,SlabTo:slab.slabTo,value : slab.slabFrom+ ' '+slab.conditionRelationalOperator+' '+slab.slabTo,ContionLogicalOperator:slab.contionLogicalOperator,CompanyId:slab.companyId,UpdatedDate:this.state.CreatedDate,UpdatedBy:this.state.CreatedBy,IsActive:slab.IsActive}
                });
                this.setState({slabs:Timeofftypeslab});
            }
        }
        

// createdDate: "2020-06-22T08:17:32.733"
// updatedDate: "2020-06-22T08:17:32.733"
// createdBy: "Fallatah Hassan Ibrahim"
// updatedBy: "Fallatah Hassan Ibrahim"


    }
 
    

    

    render() { 
        

        if(this.props.success){
            REDIRECT_TO_URL('/time-off-type-list/',this.props);
        }

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );
        
        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

        let isEnabled = (this.state.Name !== '') && (this.state.SlabFrom !== '');


        let isSaveEnabled = (this.state.Name !== null);

        let classN = 'p-col-12 p-md-4 p-lg-4';
       
        
        return (
            <div className="p-grid">
               { this.props.loading && <div className="page-loader"></div>}
               { this.state.loadingFetch && <div className="page-loader"></div>}
               { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
               { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
               <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Time Off Type</h1>       
                        <div className="p-grid">
                            <OverlayPanel  ref={el => this.overlayPanel2=el} showCloseIcon={true} dismissable={false}>
                                <DataTable value={this.state.dataTableValue} style={{width:'500px'}}>
                                        <Column field="data" header="Descriptions"  />
                                </DataTable>
                            </OverlayPanel>
                            <div className={classN}>
                                <label className="label">Name <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="width100" placeholder="Name" name="Name" value={this.state.Name} onChange={(e) => this.setState({Name:e.target.value})} />

                                </div>   
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-8">
                                <label className="label">Description</label>
                                <div className="mt1">
                                    <InputTextarea rows={3}  className="width100" placeholder="Description" name="Description" value={this.state.Description} onChange={this.onChange} autoResize={true} />
                                </div>   
                            </div>


                            <div className={classN}>
                                <label className="label">Type <span onClick={(event)=> this.overlayPanel(event,'Type')}><i className="fa fa-question-circle"></i></span> </label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Type" options={this.props.TimeOffType_Type} name="Type" value={this.state.Type} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>

                            <div className={classN}>
                                <label className="label">Booking Offset </label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Booking Offset" options={this.props.Booking_Offset} name="BookingOffset" value={this.state.BookingOffset} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>

                            <div className={classN}>
                                <label className="label">Quota Type </label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Quota Type" options={this.props.QUOTA_TYPE} name="QuotaType" value={this.state.QuotaType} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>
                            

                            <div className={classN}>
                                <label className="label">Quota Starting Date </label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Quota Starting Date " options={this.props.Quota_Starting_date} name="Quota_Starting_date" value={this.state.Quota_Starting_date} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>


                            <div className={classN}>
                                <label className="label">Booking Eligibility </label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Booking Eligibility" options={this.props.Booking_Elibility} name="BookingEligibility" value={this.state.BookingEligibility} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>

                            
                            
                            <div className={classN}>
                                <label className="label">Recurring Starts When </label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Recurring Starts When" options={this.props.Recurring_Starts_When} name="Recurring_Starts_When" value={this.state.Recurring_Starts_When} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>


                            <div className={classN}>
                                <label className="label">Pay Code</label>
                                <div className="mt1"> <InputText className="p-col-12" name="payCode"  value={this.state.payCode} onChange={this.onChange} placeholder="Enter Pay Code"/></div>                                
                            </div>


                            <div className={classN}>
                                <label className="label">Class</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Class" options={this.props.TimeoffType_Class} name="class" value={this.state.class} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>


                          

                            <div className={classN}>
                                <label className="label">Deduct From</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Deduct From" options={this.props.TimeoffType} name="Deduct_From" value={this.state.Deduct_From} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>

                            <div className={classN}>
                                <label className="label">Allowance</label>
                                <div className="mt1"> <InputText className="p-col-12" name="Allowance"  value={this.state.Allowance} onChange={this.onChange} placeholder="Enter Allowance"/></div>                                
                            </div>

                            <div className={classN}>
                                <label className="label">Duration Display</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Duration Display" options={DURATION_DISPLAY} name="Duration_Display_According_To" value={this.state.Duration_Display_According_To} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>


                            
                            

                            
                            <div className={classN}>
                                <label className="label">No of Ticket Entitlement</label>
                                <div className="mt1"> <InputText className="p-col-12" name="numberofticketentitlement"  value={this.state.numberofticketentitlement} onChange={this.onChange} placeholder="Enter No of Ticket Entitlement"/></div>                                
                            </div>
                            
                          


                            <div className={classN}>
                                <label className="label">No of Visa Entitlement</label>
                                <div className="mt1"> <InputText className="p-col-12" name="numberofvisaentitlement"  value={this.state.numberofvisaentitlement} onChange={this.onChange} placeholder="Enter No of Visa Entitlement"/></div>                                
                            </div>




                            <div className={classN}>
                                <label className="label">Allowance Entitlement Period</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Allowance Entitlement Period" options={ALLOWANCE_ENTITLEMENT} name="AllowanceEntitlementPeriod" value={this.state.AllowanceEntitlementPeriod} onChange={this.onChange} {...DROPDOWN_CONFIG}/>
                                </div>   
                            </div>


  
                            <div className={classN}>
                                <label className="label">Allow Visa Entitlement</label>
                                <div className="mt1">
                                <InputSwitch checked={this.state.Allowvisaentitlement} name="Allowvisaentitlement" onChange={this.onChange} />
                               </div>   
                            </div>



                            <div className={classN}>
                                <label className="label">Allow Multiple Bookinging Year</label>
                                <div className="mt1">
                                <InputSwitch checked={this.state.Allowmultiplebookinginayear} name="Allowmultiplebookinginayear" onChange={this.onChange} />
                               </div>   
                            </div>

                            <div className={classN}>
                                <label className="label">Allow Ticket Entitlement</label>
                                <div className="mt1">
                                <InputSwitch checked={this.state.Allowticketentitilement} name="Allowticketentitilement" onChange={this.onChange} />
                               </div>   
                            </div>



                            <div className={classN}>
                                <label className="label">Deductible</label>
                                <div className="mt1"> 
                                    <InputSwitch checked={this.state.Deductible} name="Deductible" onChange={this.onChange} />
                                </div>                                
                            </div>

                            <div className={classN}>
                                <label className="label">Exclude Weekends</label>
                                <div className="mt1">
                                    <InputSwitch checked={this.state.Excludeweekends} name="Excludeweekends" onChange={this.onChange} />
                                </div>   
                            </div>

                            <div className={classN}>
                                <label className="label">Exclude Company Holidays</label>
                                <div className="mt1">
                                    <InputSwitch checked={this.state.Excludecompanyholidays} name="Excludecompanyholidays" onChange={this.onChange} />
                                </div>   
                            </div>


                            <div className={classN}>
                                <label className="label">Evidence Attachment Must</label>
                                <div className="mt1">
                                <InputSwitch checked={this.state.Evidenceattachmentmust} name="Evidenceattachmentmust" onChange={this.onChange} />
                               </div>   
                            </div>

                        </div>
                        
                        {/* <h1>Conditions</h1>
            
                        <div className="p-grid">

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <div className="mt1 ">
                                <Dropdown className="p-col-12" options={this.state.fields} placeholder="Select Field" value={this.state.Parameter} 
                                name="Parameter" onChange={(e) => this.setState({Parameter:e.target.value})}/>
                                </div>                                
                            </div>



                            <div className="p-col-12 p-md-6 p-lg-3">
                                <div className="mt1 ">
                                <InputText className="width100" placeholder="From Value" name="SlabFrom" value={this.state.SlabFrom} onChange={(e) => this.setState({SlabFrom:e.target.value})} />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <div className="mt1 ">
                                <Dropdown className="p-col-12" options={this.state.relationalOperators} placeholder="Select Operator" value={this.state.ConditionRelationalOperator} 
                                name="ConditionRelationalOperator" onChange={(e) => this.setState({ConditionRelationalOperator:e.target.value})}/>
                                </div>                                
                            </div> */}



                            {/* <div className="p-col-12 p-md-6 p-lg-3">
                                <div className="mt1 ">
                                <InputText className="width100" placeholder="To Value" name="SlabTo" value={this.state.SlabTo} onChange={(e) => this.setState({SlabTo:e.target.value})} />
                                </div>                                
                            </div> */}

                            {/* <div className="p-col-12 p-md-6 p-lg-3">
                                <div className="mt1 ">
                                <Dropdown className="p-col-12" options={this.state.ContionLogicalOperators} placeholder="Condition Logical Operator" value={this.state.ContionLogicalOperator} 
                                name="ContionLogicalOperator" onChange={(e) => this.setState({ContionLogicalOperator:e.target.value})}/>
                                </div>                                
                            </div>

                            <div className="p-col-12 p-lg-23">
                            <div className="mt1">
                            <Button disabled={!isEnabled} style={{float:'right'}} label="Add" icon="pi pi-plus" className="ml1" onClick={this.addSlabs} />
                            </div>                                
                        </div>

                        </div>
                        <div  style={{marginTop:'2em'}}>
                            <DataTable ref={(el) => this.dt = el} value={this.state.slabs} responsive className="p-datatable-customers animated fadeIn" rowHover 
                            
                            paginator rows={10} emptyMessage="No data found" globalFilter={this.state.globalFilter} header={header}  >
                                    <Column field="Parameter" header="Conditional Field Name" />
                                    <Column field="value" header="Value" />
                                    <Column field="ContionLogicalOperator" header="Operator"  />
                                    <Column body={this.actionTemplate} header="Action" />
                                </DataTable>
                        </div> */}

                        <div className="p-col-12 p-lg-12 mt1">
                        <FooterButton access={accessButton} disabled={!isSaveEnabled} type={this.state.type.toLowerCase()} save={this.saveData} reset={this.resetData}  to={"/time-off-type-list/"} />                              
                        </div>

                        <br/><br/><br/>


                    </div>
                </div>
            </div>
                
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        fetchData : state.master.tableLists,
        TimeOffType_Type: (state.keyword.TimeOffType_Type!==undefined) ? state.keyword.TimeOffType_Type : [],
        Booking_Offset: (state.keyword.Booking_Offset!==undefined) ? state.keyword.Booking_Offset : [],
        Quota_Starting_date : (state.keyword.Quota_Starting_date!==undefined) ? state.keyword.Quota_Starting_date : [],
        Booking_Elibility : (state.keyword.Booking_Elibility!==undefined) ? state.keyword.Booking_Elibility : [],
        Recurring_Starts_When : (state.keyword.Recurring_Starts_When!==undefined) ? state.keyword.Recurring_Starts_When : [],
        TimeoffType_Class : (state.keyword.TimeoffType_Class!==undefined) ? state.keyword.TimeoffType_Class : [],
        TimeoffType : (state.keyword.TimeoffType!==undefined) ? state.keyword.TimeoffType : [],
        QUOTA_TYPE : (state.keyword.QUOTA_TYPE!==undefined) ? state.keyword.QUOTA_TYPE : [],
        
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(TimeOffType);